import React, {
  ReactElement,
} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import {serviceReservationViewTable} from "../../../schema/serviceReservationViewTable";
import {FileField} from "./fields/FileField";
import SelectStaffCell from "./SelectStaffCell";

export const AssignStaffDialog = ({
                              row,
                              onClose,

                            }: {
  onClose: () => void;
  row: any;
}): ReactElement => {

  console.log(row);

  return (
    <>
      <Dialog open={true} onClose={onClose}>
        <DialogTitle>{row?.group} - {row?.service} - Hozzárendelt fellépők</DialogTitle>
        <DialogContent>

          <SelectStaffCell rows={row?.assigned_staffs} />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Bezár</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
